<template>
  <el-dialog
    :visible.sync="isShow"
    width="600px"
    :top="isEdit ? '8vh' : '10vh'"
    :title="isEdit ? '编辑教练员' : '添加教练员'"
    :close-on-click-modal="false"
    custom-class="yioks_alert"
  >
    <div v-if="dialogLoading && isEdit" style="height: 500px">
      <yioks-loading/>
    </div>

    <template v-else>
      <el-form
        ref="coachInfo"
        :model="coachInfo"
        :rules="formRules"
        label-width="142px"
        class="demo-ruleForm"
      >
        <vue-scroll :ops="ops">
          <div
            class="coach-list-wrapper"
            v-for="(coachItem, index) in coachInfo.coachToSquads"
            :key="index"
          >
            <!-- 允许编辑信息 -->
            <template v-if="!coachItem.canEdit">
              <div class="left-box">
                <el-row>
                  <el-col :span="20">
                    <el-form-item
                      label="管理单位"
                      :prop="`coachToSquads.${index}.organUuid`"
                      :rules="[requiredItem('管理单位')]"
                    >
                      <el-select
                        v-model.trim="coachItem.organUuid"
                        @change="changeOrg(coachItem.organUuid, index)"
                        style="width: 100%"
                        placeholder="请选择管理单位"
                      >
                        <el-option
                          v-for="item in selectOrganList"
                          :key="item.organUuid"
                          :value="item.organUuid"
                          :label="item.organShortName"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item
                      label="单位"
                      :prop="`coachToSquads.${index}.youthUuid`"
                      :rules="[requiredItem('单位')]"
                    >
                      <el-select
                        v-model.trim="coachItem.youthUuid"
                        style="width: 100%"
                        placeholder="请选择管理单位后再选择单位"
                        @change="changeCenter(coachItem.youthUuid, index)"
                      >
                        <el-option
                          v-for="item in selectCenterList[index]"
                          :key="item.uuid"
                          :value="item.uuid"
                          :label="item.youthShortName"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="选择球队">
                      <el-select
                        v-model.trim="coachItem.squadUuid"
                        style="width: 100%"
                        no-data-text="暂时没有球队，请前往球队管理添加球队"
                        :placeholder="$t('teamPlaceholder')"
                        @change="changeSquad(coachItem.squadUuid, index)"
                      >
                        <el-option
                          v-for="(item, index) in squadList[index]"
                          :key="index"
                          :label="item.shortName"
                          :value="item.uuid"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="选择职位">
                      <el-select
                        v-model.trim="coachItem.duty"
                        style="width: 100%"
                        placeholder="请选择球队后再选择职位"
                      >
                        <el-option
                          v-for="(item, index) in positionList"
                          :key="index"
                          :disabled="
                            item.duty === '主教练' ? coachChoose : false
                          "
                          :label="item.duty"
                          :value="item.duty"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!--<el-row>-->
                  <!--<el-col :span="20">-->
                    <!--&lt;!&ndash; :prop="`coachToSquads.${index}.coachNature`" :rules="[requiredItem('工作类型')]" &ndash;&gt;-->
                    <!--<el-form-item label="工作类型">-->
                      <!--<el-radio-group v-model="coachItem.coachNature">-->
                        <!--<el-radio label="full_time">全职</el-radio>-->
                        <!--<el-radio label="part_time">兼职</el-radio>-->
                      <!--</el-radio-group>-->
                    <!--</el-form-item>-->
                  <!--</el-col>-->
                <!--</el-row>-->

              </div>
              <div class="right-box">
                <div
                  v-if="!(coachInfo.coachToSquads.length === 1 && index == 0)"
                >
                  <el-button
                    type="danger"
                    icon="el-icon-remove-outline"
                    circle
                    @click="handleDeleteCoachList(index)"
                  ></el-button>
                </div>
                <div style="margin-top: 10px">
                  <el-button
                    type="success"
                    icon="el-icon-circle-plus-outline"
                    circle
                    @click="handleAddCoachList"
                  ></el-button>
                </div>
              </div>
            </template>
            <!-- 不允许编辑信息 -->
            <template v-else>
              <div class="left-box">
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="管理单位">
                      <el-input v-model="coachItem.organShortName" disabled
                                placeholder="请选择管理单位"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="单位">
                      <el-input v-model="coachItem.youthShortName" disabled
                                placeholder="请选择单位"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="选择球队">
                      <el-input v-model="coachItem.shortName" disabled
                                placeholder="请选择球队"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="选择职位">
                      <el-select
                        v-model.trim="coachItem.duty"
                        style="width: 100%"
                        disabled
                        placeholder="请选择球队后再选择职位"
                      >
                        <el-option
                          v-for="(item, index) in positionList"
                          :key="index"
                          :label="item.duty"
                          :value="item.duty"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

              </div>
            </template>
          </div>

          <el-row>
            <el-col :span="20">
              <el-form-item label="教练员姓名" prop="idName">
                <el-input
                  v-model.trim="coachInfo.idName"
                  placeholder="请输入教练员姓名"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item
                label="证件类型"
                class="form_item"
                style="position: relative"
                prop="idType"
              >
                <el-select
                  v-model="coachInfo.idType"
                  placeholder="请选择证件类型"
                  :disabled="isEdit ? true : false"
                  style="width: 100%"
                  @change="changeType()"
                >
                  <el-option
                    v-for="(item, index) in id_types"
                    :key="index"
                    :label="item.key"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item
                label="颁发国家/地区"
                class="form_item"
                prop="country"
                v-if="this.coachInfo.idType === 'PASSPORT'"
              >
                <el-select
                  v-model="coachInfo.idCountry"
                  placeholder="请选择国家/地区"
                  style="width: 100%"
                  filterable
                  :disabled="isEdit ? true : false"
                >
                  <el-option
                    v-for="item in allCountry"
                    :key="item.country_code"
                    :label="item.country_zh"
                    :value="item.country_code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="颁发国家/地区"
                class="form_item"
                prop="country"
                v-if="
                  this.coachInfo.idType !== 'PASSPORT' &&
                  this.coachInfo.idType !== ''
                "
              >
                <el-select
                  v-model="coachInfo.idCountry"
                  style="width: 100%"
                  :disabled="isEdit ? true : false"
                >
                  <el-option key="CN" label="中国" value="CN"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20" style="margin-bottom: 7px">
              <el-form-item
                label="教练员身份证件号"
                class="form_item"
                prop="idNumber"
              >
                <el-input
                  v-model.trim="coachInfo.idNumber"
                  :placeholder="id_numberMsg"
                  :disabled="isEdit ? true : false"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="教练员手机号码" prop="phone">
                <el-input
                  v-model.trim="coachInfo.phone"
                  placeholder="请输入教练员手机号码"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-show="isEdit">
            <el-col :span="20">
              <el-form-item label="状态">
                <el-select
                  v-model.trim="coachInfo.userStatus"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in centerStatusList"
                    :key="index"
                    :label="item.name"
                    :value="item.status"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 是否可以创建教案  active-text="是"-->
          <el-row>
            <el-col :span="20">
              <el-form-item label="是否可以创建教案">
                <el-switch
                  v-model="coachInfo.createPlan"
                  active-color="#13ce66"
                  inactive-color="#ccc"
                  active-text="开启"
                  inactive-text="关闭"
                ></el-switch>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="isEdit">
            <el-col :span="20">
              <el-form-item label="密码" prop="password">
                <el-input
                  v-model.trim="coachInfo.password"
                  placeholder="请输入将要更改的密码"
                  type="password"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="20">
              <el-form-item label="确认密码" prop="confirmPassword">
                <el-input
                  v-model.trim="coachInfo.confirmPassword"
                  placeholder="请输入确认密码"
                  type="password"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="上传照片">
            <UploadImg
              :imgUrl.sync="coachInfo.headImgUrl"
              :avatarUrl.sync="img"
            />
            <div>支持jpg,jpeg,bmp,gif,png格式上传</div>
          </el-form-item>
          <el-row>
            <el-col :span="20">
              <el-form-item label="教练员带队年限" prop="coachLeadYears">
                <el-input
                  v-model.number="coachInfo.coachLeadYears"
                  placeholder="请输入教练员带队年限"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="输送球员情况" prop="coachTransfer">
                <el-input v-model.trim="coachInfo.coachTransfer" placeholder="请输入输送球员情况(300个字以内)" maxlength="300"
                          show-word-limit :rows="2"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="带队最好成绩" prop="coachBestResult">
                <el-input v-model.trim="coachInfo.coachBestResult" placeholder="请输入带队最好成绩(300个字以内)" maxlength="300"
                          show-word-limit :rows="2"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="最高运动经历" prop="coachBestExperience">
                <el-input v-model.trim="coachInfo.coachBestExperience" placeholder="请输入最高运动经历(300个字以内)" maxlength="300"
                          show-word-limit :rows="2"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="工作类型" prop="coachNatureCoach" :rules="[requiredItem('工作类型')]">
                <el-radio-group v-model="coachInfo.coachNatureCoach" @change="changeCoachNature">
                  <el-radio label="全职">全职</el-radio>
                  <el-radio label="兼职">兼职</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="教练员劳动/劳务关系佐证材料" :error="uploadErroeMsg" >
            <el-upload
              class="yioks-form-item"
              :action="uploadPath"
              :on-remove="handleRemoveFile"
              :before-upload="beforeUpload"
              :on-success="handleSuccessFiler"
              multiple
              :limit="1"
              :on-exceed="handleExceed"
              :file-list="uploadFileList"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                <a style="color: #666;">教练员劳动/劳务关系佐证材料（协议或社保记录等），单个上传文件大小不能超过50M,最多上传1个文件。</a>
              </div>
            </el-upload>
          </el-form-item>

<!--          <el-form-item label="教练员社保证明" v-if="coachInfo.coachNatureCoach === '全职'">-->
<!--            <el-upload-->
<!--              class="yioks-form-item"-->
<!--              :action="uploadPath"-->
<!--              :on-remove="handleRemoveFileSecurity"-->
<!--              :before-upload="beforeUpload"-->
<!--              :on-success="handleSuccessFilerSecurity"-->
<!--              multiple-->
<!--              :limit="1"-->
<!--              :on-exceed="handleExceed"-->
<!--              :file-list="uploadFileListSecurity"-->
<!--            >-->
<!--              <el-button size="small" type="primary">点击上传</el-button>-->
<!--              <div slot="tip" class="el-upload__tip">-->
<!--                <a style="color: #666;">单个上传文件大小不能超过50M,最多上传1个文件。</a>-->
<!--              </div>-->
<!--            </el-upload>-->
<!--          </el-form-item>-->

        </vue-scroll>
      </el-form>
      <div class="tip" v-if="!isEdit">
        * 该手机号将作为教练员的初始密码，身份证件号作为登录帐号
      </div>
      <div class="dialog_btn_wrap">
        <el-button
          type="primary"
          style="margin-right: 20px"
          :loading="addbtnLoading"
          @click="addCoachAccount"
        >确定
        </el-button
        >
        <el-button type="danger" @click="isShow = false">取消</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
  import wgjzz from "@/assets/images/tips/wgjzz.png";
  import HMT from "@/assets/images/tips/HMT.png";
  import HM1999 from "@/assets/images/tips/HM1999.png";
  import HM2012 from "@/assets/images/tips/HM2012.png";
  import TAI2002 from "@/assets/images/tips/TAI2002.png";
  import TAI2015 from "@/assets/images/tips/TAI2015.png";
  import coach from "@/api/coach";
  import squad from "@/api/squad";
  import person from "@/assets/images/common/person.jpg";
  import rulesMixin from "@/utils/formRules/coach";
  import {centerStatusList, id_types} from "@/utils/yioks_data";
  import storage from "@/utils/storage";
  // import { JSEncrypt } from 'jsencrypt'
  import JSEncrypt from "@/assets/js/jsencrypt.min.js";
  import auth from "@/api/auth";
  import {ops} from "@/utils/scrollIndialog";
  import squadDuty from "@/api/squadDuty";
  import {countryArr} from "@/utils/country";
  import rules from "@/utils/formRules/rules";
  import common from "@/api/common";
  import {requiredItem} from "@/assets/js/formRules";

  export default {
    name:"index",
    components:{
      UploadImg:() => import("@/components/UploadImg"),
    },
    mixins:[rulesMixin],
    props:{
      addCoach:{
        type:Boolean,
        required:true,
      },
      isEdit:{
        type:Boolean,
        required:false,
      },
      coach:{
        type:Object,
        required:false,
      },
      defaultSelect:{
        type:Object,
        required:false,
      },
    },
    data(){
      return {
        wgjzz,
        HMT,
        HM1999,
        HM2012,
        TAI2002,
        TAI2015,
        ops,
        requiredItem,
        dialogLoading:true,
        id_types:id_types,
        allCountry:countryArr.slice(1),
        id_numberMsg:"请输入身份证号",
        img:"",
        person,
        centerStatusList,
        selectOrganList:[],
        selectCenterList:[],

        positionList:[],
        squadList:[],
        userRole:storage.get("userInfo").userRole,
        addbtnLoading:false,
        coachChoose:false,
        coachChooseSquad:{
          chiefCoachUuid:"",
        },
        duty:"",
        coachInfo:{
          coachToSquads:[
            // 测试格式
            {
              organUuid:"",
              youthUuid:"",
              squadUuid:"",
              duty:"",
//              coachNature:'',  // 职位类型
            },
          ],
          phone:"",
          idName:"",
          idNumber:"",
          headImgUrl:"",
          userStatus:"EFFECTIVE",
          youthShortName:"",
          youthUuid:"",
          squadUuid:"",
          organShortName:"",
          confirmPassword:"",
          password:"",
          idCountry:"CN",
          idType:"IDNUMBER",
          verification_code:"",
          organUuid:"",
          createPlan:true,
          coachLeadYears:"",
          coachTransfer:"",
          coachBestResult:"",
          coachBestExperience:"",
          coachNatureCoach:'',
        },
        uploadErroeMsg: "", // 文件上传信息校验
        uploadFileList: [], // 文件上传组件 - 文件列表
        uploadFileListSecurity: [], // 文件上传组件 - 文件列表
        uploadFileList_edit: [], // 文件上传组件 - 编辑中新增文件
        uploadPath: "/api/zuxie/guozi/upload/uploadJixiaoFile",
        formRules:{
          idNumber:[
            {
              validator:(rule, val, callback) => {
                if(val){
                  if(this.coachInfo.idType === "IDNUMBER"){
                    if(rules.idNumber(val)){
                      // 避免验证所有表单时，重复请求
                      if(this.formRules.idNumberPass === val){
                        callback();
                      }else{
                        common
                        .checkIdNumber(val, this.formRules.userUuid)
                        .then((res) => {
                          if(res){
                            this.formRules.idNumberPass = val;
                            callback();
                          }else{
                            callback(new Error("该身份证号已经被注册（可能存在教练员同时在多个俱乐部任职的情况），请联系客服。"));
                          }
                        });
                      }
                    }else{
                      callback(new Error("请输入有效的证件号"));
                    }
                  }else if(this.coachInfo.idType === "PASSPORT"){
                    if(rules.checkPassport(val)){
                      // 避免验证所有表单时，重复请求
                      if(this.formRules.idNumberPass === val){
                        callback();
                      }else{
                        common
                        .checkIdNumber(val, this.formRules.userUuid)
                        .then((res) => {
                          if(res){
                            this.formRules.idNumberPass = val;
                            callback();
                          }else{
                            callback(new Error("该身份证号已经被注册"));
                          }
                        });
                      }
                    }else{
                      callback(new Error("请输入有效的护照号码"));
                    }
                  }else if(this.coachInfo.idType === "IDTYPECODEWGJZZ"){
                    if(rules.checkWork(val)){
                      // 避免验证所有表单时，重复请求
                      if(this.formRules.idNumberPass === val){
                        callback();
                      }else{
                        common
                        .checkIdNumber(val, this.formRules.userUuid)
                        .then((res) => {
                          if(res){
                            this.formRules.idNumberPass = val;
                            callback();
                          }else{
                            callback(new Error("该身份证号已经被注册"));
                          }
                        });
                      }
                    }else{
                      callback(new Error("请输入有效的外国人居留证号码"));
                    }
                  }else if(this.coachInfo.idType === "HM"){
                    if(rules.checkHkongMacao(val)){
                      // 避免验证所有表单时，重复请求
                      if(this.formRules.idNumberPass === val){
                        callback();
                      }else{
                        common
                        .checkIdNumber(val, this.formRules.userUuid)
                        .then((res) => {
                          if(res){
                            this.formRules.idNumberPass = val;
                            callback();
                          }else{
                            callback(new Error("该身份证号已经被注册"));
                          }
                        });
                      }
                    }else{
                      callback(
                        new Error("请输入9位有效的港澳居民来往内地通行证号码")
                      );
                    }
                  }else if(this.coachInfo.idType === "TAI"){
                    if(rules.checkTaiwOld(val)){
                      // 避免验证所有表单时，重复请求
                      if(this.formRules.idNumberPass === val){
                        callback();
                      }else{
                        common
                        .checkIdNumber(val, this.formRules.userUuid)
                        .then((res) => {
                          if(res){
                            this.formRules.idNumberPass = val;
                            callback();
                          }else{
                            callback(new Error("该身份证号已经被注册"));
                          }
                        });
                      }
                    }else{
                      callback(
                        new Error("请输入8位有效的台湾居民来往大陆通行证号码")
                      );
                    }
                  }else if(this.coachInfo.idType === "IDTYPECODEHMT"){
                    if(/^8[1-3]\d{16}/.test(val) && rules.idNumber(val)){
                      // 避免验证所有表单时，重复请求
                      if(this.formRules.idNumberPass === val){
                        callback();
                      }else{
                        common
                        .checkIdNumber(val, this.formRules.userUuid)
                        .then((res) => {
                          if(res){
                            this.formRules.idNumberPass = val;
                            callback();
                          }else{
                            callback(new Error("该身份证号已经被注册"));
                          }
                        });
                      }
                    }else{
                      callback(new Error("请输入18位有效的港澳台居民居住证号码"));
                    }
                  }
                }else{
                  callback(new Error("请输入证件号"));
                }
              },
              required:true,
              trigger:"blur",
            },
          ],
        },
        editAvaibleList:[],
      };
    },
    computed:{
      isShow:{
        get(){
          return this.addCoach;
        },
        set(val){
          this.$emit("update:addCoach", val);
        },
      },
    },
    created(){
      this.getOrgList();
      this.getDutyList();
    },

    methods:{
      changeCoachNature(){
        this.$refs['coachInfo'].clearValidate();
      },
      handleRemoveFile(file, fileList) {
        this.fileListChangedFlag = true;
        const  { meta } = file;
        if(meta && meta.uuid) {
          const {
            meta: { uuid },
          } = file;
          // 异步删除文件后，还需要手动清除当前文件列表
          this.uploadFileList = this.uploadFileList.filter((item) => {
            return item.id !== file.meta.uuid;
          });
        } else {
          this.uploadFileList = this.uploadFileList.filter((item) => {
            const  status = file.url !== item.url;
            return status
          })
        }
        //      if(this.isEdit) {
        //        this.uploadFileList_edit = this.uploadFileList_edit.filter(item => {
        //          const  status = file.url !== item.url;
        //          return status
        //        })
        //      }
      },
      handleRemoveFileSecurity(file, fileList) {
        const  { meta } = file;
        if(meta && meta.uuid) {
          const {
            meta: { uuid },
          } = file;
          // 异步删除文件后，还需要手动清除当前文件列表
          this.uploadFileListSecurity = this.uploadFileListSecurity.filter((item) => {
            return item.id !== file.meta.uuid;
          });
        } else {
          this.uploadFileListSecurity = this.uploadFileListSecurity.filter((item) => {
            const  status = file.url !== item.url;
            return status
          })
        }
        //      if(this.isEdit) {
        //        this.uploadFileList_edit = this.uploadFileList_edit.filter(item => {
        //          const  status = file.url !== item.url;
        //          return status
        //        })
        //      }
      },
      // 文件上传超出限制
      handleExceed(files, fileList) {
        this.$message.warning(`当前最多上传1个文件，请删除后再次上传。`);
      },
      //  证明材料提交成功
      handleSuccessFiler(res, file) {
        if (this.uploadErroeMsg) this.uploadErroeMsg = "";
        this.fileListChangedFlag = true;
        const { fileMd5, fileName, fileTmp, suffix, url } = res;
        const fileObj = {
          name: fileName,
          url: url,
          fileName: fileName,
          md5: fileMd5,
          fileUrl: url,
          fileType: suffix
        };
        //      if (this.isEdit) {
        //        this.uploadFileList_edit.push(fileObj);
        //      }
        this.uploadFileList.push(fileObj);
      },
      //  证明材料提交成功
      handleSuccessFilerSecurity(res, file) {
        const { fileMd5, fileName, fileTmp, suffix, url } = res;
        const fileObj = {
          name: fileName,
          url: url,
          fileName: fileName,
          md5: fileMd5,
          fileUrl: url,
          fileType: suffix
        };
        //      if (this.isEdit) {
        //        this.uploadFileList_edit.push(fileObj);
        //      }
        this.uploadFileListSecurity.push(fileObj);
      },
      // 上传文件检测
      beforeUpload(file) {
        const fileReg = /^.*\.(jpg|jpeg|png|pdf|xlsx|xls|docx|doc)$/i
        const fileType = fileReg.test(file.name)
        const fileLimit = file.size / 1024 / 1024 < 50;
        if (!fileLimit) {
          this.$message.error("单个上传文件大小不能超过50M");
          return false;
        }
        if (!fileType) {
          this.$message.error("请上传 jpg png pdf xlsx xls docx doc格式的文件");
          return false;
        }
        return fileLimit;
      },
      // 增加coachlist
      handleAddCoachList(){
        let {coachToSquads} = this.coachInfo;
        coachToSquads.push({
          organUuid:"",
          youthUuid:"",
          squadUuid:"",
          duty:"",
          coachNature:'',
          canEdit:false,
        });
        this.$set(this.coachInfo, "coachToSquads", coachToSquads);
      },
      // 删除
      handleDeleteCoachList(index){
        let {coachToSquads} = this.coachInfo;
        coachToSquads.splice(index, 1);
        if(coachToSquads.length > 0){
          coachToSquads.forEach((coachItem, coachIndex) => {
            // this.changeOrg(organUuid, coachIndex, true); // 模拟协会切换
            // this.changeCenter(youthUuid, coachIndex, true); // 模拟单位切换
            // this.changeSquad(squadUuid, coachIndex, true); // 模拟球队切换
            const editAvaibleList = this.editAvaibleList;
            if(this.userRole === "system" || this.userRole === "admin"){
              // 系统管理员可以编辑教练员所有球队信息；
              if(this.isEdit){
                coachItem.canEdit = false;
              }else{
                coachItem.canEdit = false;
              }
              this.changeOrg(coachItem.organUuid, coachIndex, true); // 模拟协会切换
              this.changeCenter(coachItem.youthUuid, coachIndex, true); // 模拟单位切换
              this.changeSquad(coachItem.squadUuid, coachIndex, true); // 模拟球队切换
            }else if(this.userRole === "organ"){
              if(editAvaibleList.includes(coachItem.organUuid)){
                if(this.isEdit){
                  coachItem.canEdit = false;
                }else{
                  coachItem.canEdit = false;
                }
                this.changeOrg(coachItem.organUuid, coachIndex, true); // 模拟协会切换
                this.changeCenter(coachItem.youthUuid, coachIndex, true); // 模拟单位切换
                this.changeSquad(coachItem.squadUuid, coachIndex, true); // 模拟球队切换
              }else{
                // 登录协会不允许编辑教练员其他协会信息
                if(this.isEdit){
                  coachItem.canEdit = true;
                }else{
                  coachItem.canEdit = false;
                }
              }
            }else if(
              this.userRole === "youth" ||
              this.userRole === "club" ||
              this.userRole === "trainCamp"
            ){
              if(editAvaibleList.includes(coachItem.youthUuid)){
//                coachItem.canEdit = false;
                if(this.isEdit){
                  coachItem.canEdit = false;
                }else{
                  coachItem.canEdit = false;
                }
                this.changeOrg(coachItem.organUuid, coachIndex, true); // 模拟协会切换
                this.changeCenter(coachItem.youthUuid, coachIndex, true); // 模拟单位切换
                this.changeSquad(coachItem.squadUuid, coachIndex, true); // 模拟球队切换
              }else{
                // 登录青训中心不允许编辑教练员其他中心所属信息
//                coachItem.canEdit = true;
                if(this.isEdit){
                  coachItem.canEdit = true;
                }else{
                  coachItem.canEdit = false;
                }
              }

            }
          });
        }
        this.$set(this.coachInfo, "coachToSquads", coachToSquads);
      },
      getDutyList(){
        squadDuty.getAllDuty().then((res) => {
          this.positionList = [
            {
              duty:"主教练",
            },
            ...res,
          ];
        });
      },
      // 判断主教练能选择不能
      changeCoachChoose(){
        if(this.isEdit){
          // 编辑
          if(this.coachChooseSquad.chiefCoachUuid){
            // 如果球队有主教练
            // 如果主教练不是他 则不能选
            if(this.coachChooseSquad.chiefCoachUuid !== this.coachInfo.uuid){
              this.coachChoose = true;
              // 如果主教练不能选了 要把已经选泽住的主教练清空
              this.duty = this.duty === "主教练" ? "" : this.duty;
            }else{
              // 已经是主教练了
              this.coachChoose = false;
            }
          }else{
            this.coachChoose = false;
          }
        }else{
          // 如果球队有主教练 则不能选
          if(this.coachChooseSquad.chiefCoachUuid){
            this.coachChoose = true;
            // 如果主教练不能选了 要把已经选泽住的主教练清空
            this.duty = this.duty === "主教练" ? "" : this.duty;
          }else{
            this.coachChoose = false;
          }
        }
      },
      addCoachAccount(){
        if(this.uploadFileList.length === 0){
          this.$message.error("请检查教练员工作合同是否上传。");
          return
        }
        this.$refs["coachInfo"].validate(async (valid) => {
          if(valid){
            const {coachToSquads} = this.coachInfo;
            this.addbtnLoading = true;
            let requestName = coach.addCoach;
            let requestData = {
              coach:{
                youthShortName:this.coachInfo.youthShortName,
                youthUuid:"", // 删
                organShortName:this.coachInfo.organShortName,
                organUuid:"", // 删
                squadUuid:"", // 删
                squadShortName:"",
                createPlan:this.coachInfo.createPlan ? 1 : 0,
                fileUrl: this.uploadFileList.length > 0 ? this.uploadFileList[0].fileUrl : "",
                fileName: this.uploadFileList.length > 0 ? this.uploadFileList[0].fileName : "",
                fileUrlSecurity: (this.uploadFileListSecurity.length > 0 && this.coachInfo.coachNatureCoach === '全职') ? this.uploadFileListSecurity[0].fileUrl : "",
                fileNameSecurity: (this.uploadFileListSecurity.length > 0 && this.coachInfo.coachNatureCoach === '全职') ? this.uploadFileListSecurity[0].fileName : "",
                coachNatureCoach: this.coachInfo.coachNatureCoach,
                coachLeadYears:this.coachInfo.coachLeadYears,
                coachTransfer:this.coachInfo.coachTransfer,
                coachBestResult:this.coachInfo.coachBestResult,
                coachBestExperience:this.coachInfo.coachBestExperience,
              },
              coachToSquads:coachToSquads,
              userForm:{
                phone:this.coachInfo.phone,
                idName:this.coachInfo.idName,
                idNumber:this.coachInfo.idNumber,
                idCountry:this.coachInfo.idCountry,
                idType:this.coachInfo.idType,
                headImgUrl:this.coachInfo.headImgUrl,
              },
            };
            if(this.isEdit){
              requestName = coach.updateCoach;
              requestData.coach.uuid = this.coachInfo.uuid;
              requestData.userForm.userStatus = this.coachInfo.userStatus;
              // requestData.userForm.password = this.coachInfo.password
              if(this.coachInfo.password){
                let username = this.coachInfo.idNumber;
                // // ras 加密
                let publicKey = await auth.getPublicKey(username);
                let encryptor = new JSEncrypt();
                encryptor.setPublicKey(publicKey);
                let rsaPassword = encryptor.encrypt(this.coachInfo.password);
                requestData.userForm.password = rsaPassword;
              }
            }
            requestName(requestData)
            .then((res) => {
              this.addbtnLoading = false;
              if(res.code){
                this.$message.error(res.msg);
              }else{
                this.$emit("hideDialog", false);
              }
            })
            .catch((err) => {
              this.addbtnLoading = false;
              console.error(err);
            });
          }
        });
      },
      // 单位切换
      changeCenter(val, index, canClear){
        !canClear ? (canClear = true) : (canClear = false);
        if(canClear && this.coachInfo.coachToSquads[index]){
          this.coachInfo.coachToSquads[index].squadUuid = "";
          this.coachInfo.coachToSquads[index].squadShortName = "";
          this.coachInfo.coachToSquads[index].coachNature && (this.coachInfo.coachToSquads[index].coachNature = "");
          // this.coachInfo.coachToSquads[index].duty = '';
          this.coachInfo.coachToSquads[index].duty &&
          (this.coachInfo.coachToSquads[index].duty = "");
        }

        if(val){
          this.squadList[index] =
            this.selectCenterList[index].find((item) => {
              return item.uuid === val;
            }).squadList || [];
        }else{
          this.squadList[index] = [];
        }
      },

      // 管理单位切换 canClear: 是否允许清除下级关联信息
      changeOrg(val, index, canClear){
        !canClear ? (canClear = true) : (canClear = false);
        this.selectCenterList[index] = [];
        // 之所以如此，大概是因为 arr[]; arr[2] = undefined;
        if(canClear && this.coachInfo.coachToSquads[index]){
          this.coachInfo.coachToSquads[index].youthUuid = "";
          this.coachInfo.coachToSquads[index].youthShortName = "";
          this.coachInfo.coachToSquads[index].coachNature &&
          (this.coachInfo.coachToSquads[index].coachNature = "");
          this.coachInfo.coachToSquads[index].squadUuid &&
          (this.coachInfo.coachToSquads[index].squadUuid = "");
          this.coachInfo.coachToSquads[index].squadShortName = "";
          this.coachInfo.coachToSquads[index].duty &&
          (this.coachInfo.coachToSquads[index].duty = "");
        }
        if(val){
          this.selectCenterList[index] =
            this.selectOrganList.find((item) => {
              return item.organUuid === val;
            }).youthList || [];
        }else{
          this.selectCenterList[index] = [];
        }
      },

      // 球队切换
      changeSquad(val, index, canClear){
        !canClear ? (canClear = true) : (canClear = false);
        if(canClear && this.coachInfo.coachToSquads[index]){
          this.coachInfo.coachToSquads[index].duty &&
          (this.coachInfo.coachToSquads[index].duty = "");
          this.coachInfo.coachToSquads[index].coachNature &&
          (this.coachInfo.coachToSquads[index].coachNature = "");
        }
        if(val){
          this.coachChooseSquad = this.squadList[index].find((item) => {
            return item.uuid === val;
          });
          this.changeCoachChoose();
        }
      },

      getOrgList(){
        let request;
        if(this.userRole === "system" || this.userRole === "admin"){
          request = squad.getOrgListBySystem;
        }else if(this.userRole === "organ"){
          request = squad.getOrgListByOrgan;
        }else if(
          this.userRole === "youth" ||
          this.userRole === "trainCamp" ||
          this.userRole === "club"
        ){
          request = squad.getOrgListByYouth;
        }
        request().then((res) => {
          this.selectOrganList = res;
          // 管理单位
          // 长度唯一；模拟自动选择
          if(this.selectOrganList.length == 1) {
            this.coachInfo.coachToSquads[0].organUuid = this.selectOrganList[0].organUuid;
            this.changeOrg(this.selectOrganList[0].organUuid, 0, true);
            if(this.selectCenterList.length == 1) {
                this.coachInfo.coachToSquads[0].youthUuid = this.selectCenterList[0][0].uuid;
                this.changeCenter(this.selectCenterList[0][0].uuid, 0, true);
                if(this.squadList[0].length == 1) {
                  this.coachInfo.coachToSquads[0].squadUuid = this.squadList[0][0].uuid;
                  this.changeSquad(this.squadList[0][0].uuid, 0, true);
                }
            }
          }
          if(this.isEdit){
            this.loadCoachInfo();
          }
          this.dialogLoading = false;
        });
      },

      changeType(){
        switch(this.coachInfo.idType){
          case "IDNUMBER": // 身份证
            this.coachInfo.idCountry = "CN";
            this.id_numberMsg = "请输入身份证号";
            break;
          case "IDTYPECODEWGJZZ": // 外国人永久居留身份证
            this.coachInfo.idCountry = "CN";
            this.id_numberMsg = "例如：CAN000000000000";
            break;
          case "IDTYPECODEHMT": // 港澳台居民居住证
            this.coachInfo.idCountry = "CN";
            this.id_numberMsg = "请输入港澳台居民居住证号";
            break;
          case "HM": // 港澳居民来往内地通行证
            this.coachInfo.idCountry = "CN";
            this.id_numberMsg = "例如：H00000000";
            break;
          case "TAI": // 台湾居民来往大陆通行证
            this.coachInfo.idCountry = "CN";
            this.id_numberMsg = "例如：00000000";
            break;
          case "PASSPORT": // 护照（非中国大陆人员）
            this.coachInfo.idCountry = "";
            this.id_numberMsg = "例如：E00000000";
            break;
        }
      },

      // 获取教练个人信息 // 设置编辑回显数据
      async loadCoachInfo(){
        this.dialogLoading = true;
        const {uuid} = this.coach;
        try{
          const res = await coach.getCoachInfo(uuid);
          if(res.code){
            this.$message.error(res.msg);
            return;
          }
          let {
            squadInformationALL:coachToSquads,
            coachInformation:{createPlan},
          } = res;
          this.formRules.idNumberPass = this.coach.idNumber;
          this.formRules.userUuid = this.coach.uuid;

          let editAvaibleList = [];
          if(this.userRole === "system" || this.userRole === "admin"){
            this.selectOrganList.forEach((item) => {
              editAvaibleList.push(item.organUuid);
            });
          }else if(this.userRole === "organ"){
            this.selectOrganList.forEach((item) => {
              editAvaibleList.push(item.organUuid);
            });
          }else if(
            this.userRole === "club" ||
            this.userRole === "youth" ||
            this.userRole === "trainCamp"
          ){
            const {youthList} = this.selectOrganList[0];
            youthList.forEach((item) => {
              editAvaibleList.push(item.uuid);
            });
          }
          this.editAvaibleList = editAvaibleList;

          if(coachToSquads.length > 0){
            coachToSquads.forEach((coachItem, coachIndex) => {
              if(this.userRole === "system" || this.userRole === "admin"){
                // 系统管理员可以编辑教练员所有球队信息；
                coachItem.canEdit = false;
                this.changeOrg(coachItem.organUuid, coachIndex); // 模拟协会切换
                this.changeCenter(coachItem.youthUuid, coachIndex); // 模拟单位切换
                this.changeSquad(coachItem.squadUuid, coachIndex); // 模拟球队切换
              }else if(this.userRole === "organ"){
                if(editAvaibleList.includes(coachItem.organUuid)){
                  coachItem.canEdit = false;
                  this.changeOrg(coachItem.organUuid, coachIndex); // 模拟协会切换
                  this.changeCenter(coachItem.youthUuid, coachIndex); // 模拟单位切换
                  this.changeSquad(coachItem.squadUuid, coachIndex); // 模拟球队切换
                }else{
                  // 登录协会不允许编辑教练员其他协会信息
                  coachItem.canEdit = true;
                }
              }else if(
                this.userRole === "youth" ||
                this.userRole === "club" ||
                this.userRole === "trainCamp"
              ){
                if(editAvaibleList.includes(coachItem.youthUuid)){
                  coachItem.canEdit = false;
                  this.changeOrg(coachItem.organUuid, coachIndex); // 模拟协会切换
                  this.changeCenter(coachItem.youthUuid, coachIndex); // 模拟单位切换
                  this.changeSquad(coachItem.squadUuid, coachIndex); // 模拟球队切换
                }else{
                  // 登录青训中心不允许编辑教练员其他中心所属信息
                  coachItem.canEdit = true;
                }
              }

            });
          }
          this.coachInfo = Object.assign({}, this.coach, {
            password:"",
            confirmPassword:"",
            createPlan:createPlan && Number(createPlan) === 1 ? true : false,
            coachToSquads,
          });
          if(this.coachInfo.fileUrl){
            const fileObj = {
              name: this.coachInfo.fileName,
              url: this.coachInfo.fileUrl,
              fileName: this.coachInfo.fileName,
              fileUrl: this.coachInfo.fileUrl
            };
            this.uploadFileList.push(fileObj);
          }
          if(this.coachInfo.fileUrlSecurity){
            const fileObj = {
              name: this.coachInfo.fileNameSecurity,
              url: this.coachInfo.fileUrlSecurity,
              fileName: this.coachInfo.fileNameSecurity,
              fileUrl: this.coachInfo.fileUrlSecurity
            };
            this.uploadFileListSecurity.push(fileObj);
          }
          this.dialogLoading = false;
        }catch(err){
          console.error("err", err);
        }
      },
    },
  };
</script>

<style scoped lang="stylus">
  .demo-ruleForm
    height 500px

  .tip
    margin-top 10px
    color red
    width 100%
    text-align center
    word-break break-word

  .coach-list-wrapper
    width 95%
    display flex
    justify-content space-around
    border-bottom 1px dashed #CCCCCC
    border-top 1px dashed #CCCCCC
    padding 20px 20px 0px 0px
    margin-bottom 20px

    .left-box
      width 100%

    .right-box
      width 40px
      display flex
      justify-content center
      flex-direction column
      align-items center


  /deep/ .el-upload-list
    width: 96% !important
</style>
